function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useRef as l, useState as S, useEffect as y } from "react";
import { visibilityControls as w } from "./index.es509.js";
import "./index.es15.js";
import "./index.es172.js";
var C = function C(_ref) {
  var f = _ref.onChangeVisibleRef,
    p = _ref.visibilityRef,
    _ref$isVisibleDisable = _ref.isVisibleDisabled,
    u = _ref$isVisibleDisable === void 0 ? !1 : _ref$isVisibleDisable,
    m = _ref.hideOnScroll,
    _ref$isAlwaysVisible = _ref.isAlwaysVisible,
    T = _ref$isAlwaysVisible === void 0 ? !1 : _ref$isAlwaysVisible,
    d = _ref.showTooltipDelay,
    r = _ref.allowPreinstallNode;
  var o = l(null),
    n = l(null),
    _S = S(u || r || T),
    _S2 = _slicedToArray(_S, 2),
    h = _S2[0],
    a = _S2[1],
    i = l(!0),
    B = function B(e) {
      e ? i.current = e : document.hidden && (i.current = !1);
    },
    E = function E() {
      n.current && (clearInterval(n.current), n.current = null), o.current && (clearInterval(o.current), o.current = null);
    },
    v = function v(e) {
      r || (E(), a(e));
    },
    _s = function s(e) {
      v(!1);
      var t = function t() {
        var c = !e;
        f.current(!1), w.hide(p.current), c && window.removeEventListener("scroll", _s, !0);
      };
      r ? t() : n.current = setTimeout(t, d);
    },
    I = function I(e, t) {
      v(!0);
      var c = function c() {
        e(), f.current(!0), t && t(), w.show(p.current), !u && m && window.addEventListener("scroll", _s, {
          passive: !0,
          capture: !0,
          once: !0
        });
      };
      r ? c() : o.current = setTimeout(c, d);
    };
  return y(function () {
    return function () {
      window.removeEventListener("scroll", _s, !0);
    };
  }, [u, m, T]), {
    hideTooltip: _s,
    showTooltip: I,
    changeBrowserTabVisibility: B,
    isVisibleTab: i,
    isVisibleTooltip: h
  };
};
export { C as useControlVisible };